/**
 * Totesly — custom storefront enhancements
 * ----------------------------------------
 * 1. Sticky mobile add-to-cart bar on product pages.
 *    It does NOT reimplement cart logic — it forwards the tap to the theme's
 *    own add-to-cart button, so all existing behaviour and validation is reused.
 * 2. Small mobile usability refinements (tap targets, spacing, safe-area).
 *
 * Safe to remove: deleting this file only removes the enhancements.
 */
(function () {
  'use strict';

  var STYLES = [
    '.tl-atc{position:fixed;left:0;right:0;bottom:0;z-index:60;display:flex;align-items:center;gap:12px;',
    'background:#f5f2ec;border-top:1px solid #ded8ce;box-shadow:0 -6px 24px rgba(36,33,29,.12);',
    'padding:10px 12px;padding-bottom:calc(10px + env(safe-area-inset-bottom,0px));',
    'transform:translateY(115%);transition:transform .28s cubic-bezier(.4,0,.2,1);will-change:transform}',
    '.tl-atc.is-visible{transform:translateY(0)}',
    '.tl-atc__info{flex:1 1 auto;min-width:0;line-height:1.3}',
    '.tl-atc__title{display:block;font-size:12.5px;color:#3a3630;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.tl-atc__price{display:block;font-size:15px;font-weight:700;color:#24211d;margin-top:2px}',
    '.tl-atc__btn{flex:0 0 auto;appearance:none;border:0;cursor:pointer;background:#36332e;color:#f5f2ec;',
    'font:inherit;font-size:11px;letter-spacing:.16em;text-transform:uppercase;padding:15px 22px;min-height:48px}',
    '.tl-atc__btn:disabled{opacity:.45;cursor:not-allowed}',
    '.tl-atc__btn:active{background:#4a4640}',
    '@media(min-width:750px){.tl-atc{display:none}}',
    '@media(max-width:749px){',
    '.template-product .ProductForm__AddToCart,.template-product .Button--full{min-height:52px;font-size:12px}',
    '.template-product .ProductMeta__Title{font-size:24px;line-height:1.25}',
    '.template-product .Product__Info,.template-product .ProductMeta{padding-bottom:76px}',
    '.Rte table{display:block;overflow-x:auto;-webkit-overflow-scrolling:touch}',
    '.Rte img{height:auto}',
    '}'
  ].join('');

  function injectStyles() {
    if (document.getElementById('tl-custom-styles')) return;
    var s = document.createElement('style');
    s.id = 'tl-custom-styles';
    s.textContent = STYLES;
    document.head.appendChild(s);
  }

  function q(selectors, root) {
    root = root || document;
    for (var i = 0; i < selectors.length; i++) {
      var el = root.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function findAddButton() {
    return q([
      '.ProductForm__AddToCart',
      'form[action*="/cart/add"] button[name="add"]',
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] input[type="submit"]'
    ]);
  }

  function readPrice() {
    var el = q([
      '.ProductMeta__PriceList .Price--highlight',
      '.ProductMeta__PriceList .Price',
      '.ProductMeta__Price',
      '.Product__Info .Price'
    ]);
    return el ? el.textContent.trim() : '';
  }

  function readTitle() {
    var el = q(['.ProductMeta__Title', '.Product__Info h1', 'h1']);
    return el ? el.textContent.trim() : '';
  }

  function init() {
    if (!document.body.classList.contains('template-product')) return;

    var realBtn = findAddButton();
    if (!realBtn) return;

    injectStyles();

    var bar = document.createElement('div');
    bar.className = 'tl-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');

    var info = document.createElement('div');
    info.className = 'tl-atc__info';

    var titleEl = document.createElement('span');
    titleEl.className = 'tl-atc__title';
    titleEl.textContent = readTitle();

    var priceEl = document.createElement('span');
    priceEl.className = 'tl-atc__price';
    priceEl.textContent = readPrice();

    info.appendChild(titleEl);
    info.appendChild(priceEl);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tl-atc__btn';

    function syncButton() {
      var label = (realBtn.textContent || '').trim() || 'Add to cart';
      btn.textContent = label;
      btn.disabled = !!realBtn.disabled;
      priceEl.textContent = readPrice();
    }
    syncButton();

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      realBtn.click();
    });

    bar.appendChild(info);
    bar.appendChild(btn);
    document.body.appendChild(bar);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      io.observe(realBtn);
    } else {
      bar.classList.add('is-visible');
    }

    document.addEventListener('variant:changed', syncButton);
    if ('MutationObserver' in window) {
      new MutationObserver(syncButton).observe(realBtn, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled', 'class']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();